import { BackendModel, BackendService } from './backend.service';
import { DecimalPipe } from '@angular/common';

export class Dolar {

  static path = '/dolar/';

  compra: number;
  venta: number;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/app/core/dolar.model.ts